export function applyAuthSession(data = {}) {
  localStorage.removeItem("factlify_workspace");
  sessionStorage.removeItem("factlify_onboarding_skipped");
  if (data.session_token) {
    localStorage.setItem("factlify_token", data.session_token);
  }
  if (data.workspace_id) {
    localStorage.setItem("factlify_workspace", data.workspace_id);
  }
}

export function clearAuthSession() {
  localStorage.removeItem("factlify_token");
  localStorage.removeItem("factlify_workspace");
  sessionStorage.removeItem("factlify_onboarding_skipped");
}

/**
 * Detects the backend's "stale workspace" rejection: a 403 whose detail is
 * exactly "Not a member of this workspace" (raised by deps.get_current_user
 * and subscription_mw when X-Workspace-Id points to a workspace the user no
 * longer belongs to — deleted workspace, revoked membership, or storage left
 * over from another account on the same browser).
 *
 * Role-based 403s use different details ("Insufficient role for this action",
 * "Only the owner can ..."), so matching the exact message cannot misfire on
 * a legitimate permission error.
 */
export function isStaleWorkspaceError(err) {
  if (err?.response?.status !== 403) return false;
  return err?.response?.data?.detail === "Not a member of this workspace";
}

/**
 * Recovery: drop only the stale workspace id (the session token stays valid)
 * so the next request goes without X-Workspace-Id and the backend falls back
 * to the user's personal/default workspace. Returns true when a reset
 * happened, so the caller can trigger a reload.
 */
export function resetStaleWorkspace() {
  if (!localStorage.getItem("factlify_workspace")) return false;
  localStorage.removeItem("factlify_workspace");
  return true;
}
